// extracted by mini-css-extract-plugin
export default {"customerInfo":"CustomerInfo_customerInfo__amTjf","flexRightContainer":"CustomerInfo_flexRightContainer__MkQTH"};